

















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Poi, PoiState } from '@/models/poi';
import { urlize } from '@/utils';
import Bro from 'brototype';

@Component
export default class PoiCard extends Vue {
    @Prop(Object) public poi: Poi;
    @Prop({ default: true }) public lazy?: boolean;

    get isNotUnlocked(): boolean {
        return this.poi.state !== PoiState.UNLOCKED;
    }

    get distanceDisplay() {
        if (this.poi.distance <= 0) {
            return '';
        } else if (this.poi.distance <= 1000) {
            return Math.ceil(this.poi.distance) + ' m';
        } else {
            return (this.poi.distance / 1000).toFixed(1) + ' km';
        }
    }

    get lockIcon(): string {
        switch (this.poi.state) {
            case PoiState.LOCKED:
                return 'lock';
            case PoiState.READY_TO_UNLOCK:
                return 'vpn_key';
            case PoiState.UNLOCKED:
                return 'lock_open';
            default:
                return 'lock';
        }
    }

    get isReady(): boolean {
        return this.poi.state === PoiState.READY_TO_UNLOCK;
    }

    get backgroundImage() {
        if (Bro(this.poi).doYouEven('content_images.0.image.medium')) {
            return urlize(this.poi.content_images[0].image.medium);
        }
        return '';
    }
}
